module.exports = __webpack_public_path__ + "img/samsung-galaxy-a7.37b7a057.png";